module.exports = __webpack_public_path__ + "components/scroll-button/static/icon-chevron-circle-right-0390092ba7b953e9b602aa7945719416.svg";